import React from "react";
import { Modal, Form, Input } from "antd";
import { passwordRegex } from "../../utils/helpers";
import DsTheme from "./DsTheme";

const ChangePasswordModal = ({ open, onClose, onSubmit }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onSubmit(values); // send old, new, confirm
    form.resetFields();
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <DsTheme>
      <Modal
        className="ds-modal"
        open={open}
        width={460}
        footer={null}
        closable={false}
        destroyOnHidden
        onCancel={handleClose}
      >
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <div className="dlg-header">
            <div className="dlg-header-left">
              <span className="dlg-icon">
                <span className="material-symbols-outlined">lock_reset</span>
              </span>
              <div>
                <h3 className="dlg-title">Change Password</h3>
                <p className="dlg-sub">Update the password for your account</p>
              </div>
            </div>
            <button
              type="button"
              className="dlg-close"
              onClick={handleClose}
              aria-label="Close"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>

          <div className="dlg-body">
            <p className="section-label">Current</p>
            <Form.Item
              name="old_password"
              label="Old Password"
              rules={[{ required: true, message: "Old password is required" }]}
            >
              <Input.Password placeholder="Enter old password" />
            </Form.Item>

            <p className="section-label">New</p>
            <Form.Item
              name="new_password"
              label="New Password"
              extra="8–15 characters with upper & lower case, a number and a special character."
              rules={[
                { required: true, message: "New password is required" },
                {
                  pattern: passwordRegex,
                  message:
                    "Password must contain upper, lower, number, special char (8–15 chars)",
                },
              ]}
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>

            <Form.Item
              name="confirm_password"
              label="Confirm Password"
              dependencies={["new_password"]}
              rules={[
                { required: true, message: "Confirm your password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Passwords do not match");
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>
          </div>

          <div className="dlg-footer">
            <button type="button" className="btn-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button type="submit" className="btn-save">
              Save Password
            </button>
          </div>
        </Form>
      </Modal>
    </DsTheme>
  );
};

export default ChangePasswordModal;
